<ng-container *ngIf="_control && _control.value !== undefined && _control.errors && (_control.dirty || _control.touched)">
    <ng-container *ngIf="!_control.valid">
        <div class="ui-field-message ui-error" title="{{_control.errors['message'] | translate}}">
            {{_control.errors['message'] | translate}}
        </div>
    </ng-container>
</ng-container>
